// 由 schoolclass/convert.js 自动生成
const data = {
  "1": [
    {
      "sub": "自动控制原理",
      "tec": "崔长春",
      "week": "6-16,18周",
      "add": "教学楼B座317能动"
    },
    {
      "sub": "高等数学基础（一）",
      "tec": "尤福财",
      "week": "6-16,18周",
      "add": "教学楼C座112教务"
    },
    0,
    {
      "sub": "马克思主义基本原理",
      "tec": "高雪",
      "week": "6-17周",
      "add": "教学楼A座426机械"
    },
    0
  ],
  "2": [
    0,
    {
      "sub": "工程热力学",
      "tec": "张磊李振南",
      "week": "6-16,18周",
      "add": "教学楼B座219能动"
    },
    {
      "sub": "军事理论",
      "tec": "王星月",
      "week": "12,14-16,18-19周",
      "add": "教学楼B座324能动"
    },
    {
      "sub": "就业创业指导",
      "tec": "孙宏英",
      "week": "12-16周",
      "add": "教学楼B座422能动"
    },
    0
  ],
  "3": [
    {
      "sub": "基础英语（一）",
      "tec": "宋大明",
      "week": "6-17周",
      "add": "教学楼D座513能动AISEC"
    },
    [
      {
        "sub": "能源与动力工程专业导论",
        "tec": "刘耀鑫申宇王强夏永军",
        "week": "6-12周",
        "add": "教学楼B座219能动"
      },
      {
        "sub": "能源与动力工程专业导论",
        "tec": "刘耀鑫申宇王强",
        "week": "13-16,18周",
        "add": "教学楼B座219能动"
      }
    ],
    0,
    {
      "sub": "军事理论",
      "tec": "王星月",
      "week": "9,11,13周",
      "add": "教学楼B座324能动"
    },
    0
  ],
  "4": [
    {
      "sub": "马克思主义基本原理",
      "tec": "高雪",
      "week": "6-17周",
      "add": "教学楼A座425机械"
    },
    0,
    {
      "sub": "高等数学基础（一）",
      "tec": "尤福财",
      "week": "6-16双周",
      "add": "教学楼C座112教务"
    },
    0,
    {
      "sub": "形势与政策",
      "tec": "杨淑一",
      "week": "6-9周",
      "add": "教学楼C座306教务"
    }
  ],
  "5": [
    {
      "sub": "工程热力学",
      "tec": "张磊李振南",
      "week": "6-16,18周",
      "add": "教学楼B座219能动"
    },
    {
      "sub": "基础英语（一）",
      "tec": "宋大明",
      "week": "7,9,11,13,15,17周",
      "add": "教学楼D座513能动AISEC"
    },
    0,
    0,
    0
  ],
  "6": [
    0,
    0,
    0,
    0,
    0
  ],
  "7": [
    0,
    0,
    0,
    0,
    0
  ]
};
export default data;
